module.exports = __webpack_public_path__ + "static/sadiebike-7ec129d7f0ed5a0570e522ea50d99da8.jpg";